// external
import React, { useCallback, memo } from "react";
import { PropTypes } from "prop-types";

// internal
import SelectCasting from "components/utils/SelectCasting";

function ContentAdminCast({
  type,
  title,
  separator,
  items,
  isDisabled,
  onUpdateCasting,
  castings,
}) {
  const onUpdate = useCallback((castings) => onUpdateCasting(castings, type));

  return (
    <div
      className={
        separator
          ? "editor-form-section section-separator"
          : "editor-form-section"
      }
    >
      <div className="editor-form-section-title">{title}</div>
      <div className="editor-form-input">
        <SelectCasting
          disabled={isDisabled}
          onUpdate={onUpdate}
          items={items}
          type={type}
          castings={castings}
        />
      </div>
    </div>
  );
}

ContentAdminCast.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onUpdateCasting: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  separator: PropTypes.bool,
  castings: PropTypes.object.isRequired,
};

ContentAdminCast.defaultProps = {
  separator: false,
};

export default memo(ContentAdminCast);
